/* 时间轴 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import publicStyle from '../public/newsGroup.css';
import { classnames } from '../../../utils/classnames';

class TimeLine extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
        componentOptions: PropTypes.object,
    };

    state = {
        index: 0,
    };

    handleTitleMouseOver(index) {
        this.setState({ index });
    }
    listView(list = []) {
        const index2 = this.state.index;

        return list.map((item, index) => {
            return (
                <dl key={index} className={styles.lineDl}>
                    <dt className={styles.lineDt} onMouseOver={this.handleTitleMouseOver.bind(this, index)}>
                        {item.title}
                    </dt>
                    {index2 === index ? <dd className={styles.lineDd}>{item.summary}</dd> : null}
                    <i className={styles.icon} />
                </dl>
            );
        });
    }
    render() {
        const {
            content,
            componentOptions: { infoTitle },
        } = this.props;

        return (
            <div className={publicStyle.news_group}>
                {/* 标题 */}
                <div className={`${publicStyle.news_group_title} clearfix`}>
                    <i className={classnames(publicStyle.block, 'block')} />
                    <span className={publicStyle.link_title}>{infoTitle}</span>
                </div>
                <div className={styles.lineBox}>
                    {this.listView(content)}
                    <div className={styles.line} />
                </div>
            </div>
        );
    }
}

export default errorBoundary(TimeLine);
